/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockOrderCheckInfoVo } from './StockOrderCheckInfoVo';
import {
    StockOrderCheckInfoVoFromJSON,
    StockOrderCheckInfoVoFromJSONTyped,
    StockOrderCheckInfoVoToJSON,
    StockOrderCheckInfoVoToJSONTyped,
} from './StockOrderCheckInfoVo';

/**
 * 
 * @export
 * @interface ResponseStockOrderCheckInfoVo
 */
export interface ResponseStockOrderCheckInfoVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseStockOrderCheckInfoVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseStockOrderCheckInfoVo
     */
    message?: string;
    /**
     * 
     * @type {StockOrderCheckInfoVo}
     * @memberof ResponseStockOrderCheckInfoVo
     */
    data?: StockOrderCheckInfoVo;
}

/**
 * Check if a given object implements the ResponseStockOrderCheckInfoVo interface.
 */
export function instanceOfResponseStockOrderCheckInfoVo(value: object): value is ResponseStockOrderCheckInfoVo {
    return true;
}

export function ResponseStockOrderCheckInfoVoFromJSON(json: any): ResponseStockOrderCheckInfoVo {
    return ResponseStockOrderCheckInfoVoFromJSONTyped(json, false);
}

export function ResponseStockOrderCheckInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseStockOrderCheckInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : StockOrderCheckInfoVoFromJSON(json['data']),
    };
}

export function ResponseStockOrderCheckInfoVoToJSON(json: any): ResponseStockOrderCheckInfoVo {
    return ResponseStockOrderCheckInfoVoToJSONTyped(json, false);
}

export function ResponseStockOrderCheckInfoVoToJSONTyped(value?: ResponseStockOrderCheckInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': StockOrderCheckInfoVoToJSON(value['data']),
    };
}

